// export const apiurl = 'http://idps.kelan.cc/idps/web' // 接口域名
export const apiurl = 'http://school.kelan.cc/school/web' // 接口域名
export const imgurl = 'http://school.kelan.cc/school' // 图片域名


// export const apiurl="http://localhost:8088/school/web" // 接口域名
// export const imgurl="http://localhost:8088/school/" // 图片域名 



// WEBPACK FOOTER //
// ./src/common/js/baseApi.js